export const FLEET_TOPIC = '/visualization/fleet/observed'
const id = value => typeof value === 'string' && /^[A-Za-z0-9_-]{1,64}$/.test(value)
const count = value => Number.isSafeInteger(value) && value >= 0

export function fleetQuery (input) {
  if (!input || typeof input !== 'object' || Array.isArray(input) || Object.keys(input).some(key => !['kind', 'ids', 'productId', 'pageId', 'componentId'].includes(key)) ||
      !['device', 'product'].includes(input.kind) || !Array.isArray(input.ids) || !input.ids.length || input.ids.length > 100 || input.ids.some(value => !id(value)) || new Set(input.ids).size !== input.ids.length) throw new Error('列表实时范围无效')
  for (const key of ['productId', 'pageId', 'componentId']) if (input[key] !== undefined && input[key] !== '' && !id(input[key])) throw new Error('列表实时绑定无效')
  if (!!input.pageId !== !!input.componentId || input.kind === 'product' && input.productId) throw new Error('列表实时范围无效')
  return { kind: input.kind, ids: [...input.ids].sort(), ...(input.productId ? { productId: input.productId } : {}), ...(input.pageId ? { pageId: input.pageId, componentId: input.componentId } : {}) }
}

export function fleetSnapshot (value, query) {
  const reject = () => { throw new Error('列表实时快照无效，请重试') }
  if (!value || value.kind !== 'snapshot' || value.listKind !== query.kind || (value.productId || '') !== (query.productId || '') ||
      !Array.isArray(value.ids) || JSON.stringify(value.ids) !== JSON.stringify(query.ids) || !Array.isArray(value.rows) || value.rows.length > query.ids.length || !count(value.revision)) reject()
  const seen = new Set(), rows = value.rows.map(row => {
    if (!row || !query.ids.includes(row.id) || seen.has(row.id)) reject()
    seen.add(row.id)
    if (query.kind === 'product') {
      if (!count(row.deviceCount) || !count(row.onlineCount) || row.onlineCount > row.deviceCount) reject()
      return { id: row.id, deviceCount: row.deviceCount, onlineCount: row.onlineCount }
    }
    if (!id(row.productId) || query.productId && query.productId !== row.productId || !['online', 'offline', 'notActive', 'unknown'].includes(row.state)) reject()
    if (row.lastReportTime !== undefined && (!Number.isSafeInteger(row.lastReportTime) || row.lastReportTime <= 0 || row.lastReportTime > Date.now() + 300000)) reject()
    return { id: row.id, productId: row.productId, state: row.state, ...(row.lastReportTime ? { lastReportTime: row.lastReportTime } : {}) }
  })
  return { ...value, rows }
}

// 在当前滚动视口内取ID；滚动加载的旧批次不持续占用后台订阅。
export function visibleFleetIds (element, rows) {
  if (!element || typeof element.getBoundingClientRect !== 'function' || !element.querySelectorAll) return []
  const rect = element.getBoundingClientRect(), allowed = new Set(rows.map(row => row.id)), ids = []
  if (rect.bottom <= rect.top || rect.right <= rect.left) return []
  for (const node of element.querySelectorAll('[data-fleet-live-id]')) {
    const id = node.getAttribute('data-fleet-live-id'), bounds = node.getBoundingClientRect()
    if (allowed.has(id) && bounds.bottom > rect.top && bounds.top < rect.bottom && bounds.right > rect.left && bounds.left < rect.right) ids.push(id)
    if (ids.length === 100) break
  }
  return [...new Set(ids)].sort()
}

export function lastReportText (timestamp) {
  if (!Number.isSafeInteger(timestamp) || timestamp <= 0) return ''
  const date = new Date(timestamp), pad = value => String(value).padStart(2, '0')
  return '最近上报 ' + date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()) + ' ' + pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds())
}

export function mergeFleetRows (rows, snapshot) {
  const scope = new Set(snapshot.ids), values = new Map(snapshot.rows.map(row => [row.id, row]))
  return rows.filter(row => !scope.has(row.id) || values.has(row.id)).map(row => {
    if (!scope.has(row.id)) return row
    const value = values.get(row.id)
    if (snapshot.listKind === 'product') return { ...row, deviceCount: value.deviceCount, onlineCount: value.onlineCount }
    // 最新时间只来自平台属性上报缓存，不把上线/离线时间或浏览器时间冒充上报时间。
    return { ...row, state: value.state, lastReportTime: value.lastReportTime, lastSeen: lastReportText(value.lastReportTime) }
  })
}
